import type { AlertStyles } from '../../ThemeTypes';
import colors from '../colors';
import fonts from '../fonts';

const alert: AlertStyles = {
  alert: {
    border: 'none',
    fontWeight: fonts.fontWeights.bold,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.4)',

    '&.alert-primary': {
      color: colors.white,
      backgroundImage: colors.gradients.primary,
    },
    '&.alert-secondary': {
      color: colors.white,
      backgroundImage: colors.gradients.secondary,
    },
    '&.alert-success': {
      color: colors.white,
      backgroundImage: colors.gradients.success,
    },
    '&.alert-danger': {
      color: colors.white,
      backgroundImage: colors.gradients.danger,
    },
    '&.alert-warning': {
      color: colors.white,
      backgroundImage: colors.gradients.info,
    },
    '&.alert-info': {
      color: colors.white,
      backgroundImage: colors.gradients.info,
    },
    '&.alert-light': {
      color: colors.dark,
      background: colors.light,
    },
    '&.alert-dark': {
      color: colors.white,
      background: colors.dark,
    },

    '.close': {
      fontWeight: fonts.fontWeights.semilight,
      opacity: 1,
      fontSize: '35px',
      lineHeight: '0.75',
      textShadow: 'none',
    },
  },
};

export default alert;
